import PropTypes from 'prop-types';

function CustomTooltip({ active, payload, label, isPercentage = false }) {
  if (active && payload && payload.length) {
    return (
      <div
        className="rounded shadow-lg p-3 font-montserrat"
        style={{
          background: "#f9fafb",
          color: "#1e293b",
          border: "1px solid #d1d5db",
        }}
      >
        <div className="font-semibold mb-1">{label}</div>
        {payload.map((entry) => (
          <div key={entry.name} className="flex gap-2 items-center">
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: entry.color,
                marginRight: 4,
              }}
            />
            <span style={{ fontWeight: "bold" }}>{entry.name}</span>
            <span>
              : {entry.value} {isPercentage && "%"}
            </span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string,
  isPercentage: PropTypes.bool,
}

export default CustomTooltip